import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { getAgreeStatus } from "@/api/aijiaoaiCourse";
@Component({})
export default class LikeOrNot extends Vue {
    private agreeStatus: string = "";
    @Prop() private item: any;
    private agreeId: number = null;
    mounted() {
        this.agreeStatus = this.item.agreeStatus;
    }

    handleThumbClick(val, itemData) {
        if (val === "like") {
            if (this.agreeStatus !== "AGREE") {
                this.agreeStatus = "AGREE";
            } else {
                this.agreeStatus = "NORMAL";
            }
            this.agreeId = itemData.id;
            this.fetchAgreeStatus(itemData);
        } else if (val === "dislike") {
            if (this.agreeStatus !== "TREAD") {
                this.agreeStatus = "TREAD";
            } else {
                this.agreeStatus = "NORMAL";
            }
            this.agreeId = itemData.id;
            this.fetchAgreeStatus(itemData);
        }
    }
    fetchAgreeStatus(itemData) {
        getAgreeStatus(this.agreeStatus, this.agreeId).then(res => {
            //@ts-ignore
            if (res.code === 200 && res.data) {
                this.$set(itemData, "agreeStatus", this.agreeStatus);
            }
        });
    }
}

//@ts-ignore
export { default as LikeOrNot } from "./index.vue";
